type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  color?: string;
};

const ShareUpIcon = (props: Props) => {
  const {
    width = '17',
    height = '16',
    viewBox = '0 0 17 16',
    color = '#F2D093',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <path
        d="M15 7.38488V14.7693C15 15.0957 14.8659 15.4087 14.6272 15.6395C14.3885 15.8703 14.0648 16 13.7273 16H2.27273C1.93518 16 1.61146 15.8703 1.37277 15.6395C1.13409 15.4087 1 15.0957 1 14.7693V7.38488C1 7.05847 1.13409 6.74542 1.37277 6.51462C1.61146 6.28381 1.93518 6.15414 2.27273 6.15414H4.18182C4.35059 6.15414 4.51245 6.21898 4.63179 6.33438C4.75114 6.44978 4.81818 6.60631 4.81818 6.76951C4.81818 6.93272 4.75114 7.08924 4.63179 7.20464C4.51245 7.32004 4.35059 7.38488 4.18182 7.38488H2.27273V14.7693H13.7273V7.38488H11.8182C11.6494 7.38488 11.4875 7.32004 11.3682 7.20464C11.2489 7.08924 11.1818 6.93272 11.1818 6.76951C11.1818 6.60631 11.2489 6.44978 11.3682 6.33438C11.4875 6.21898 11.6494 6.15414 11.8182 6.15414H13.7273C14.0648 6.15414 14.3885 6.28381 14.6272 6.51462C14.8659 6.74542 15 7.05847 15 7.38488ZM5.26841 4.12805L7.36364 2.10119V9.23098C7.36364 9.39418 7.43068 9.5507 7.55002 9.6661C7.66936 9.78151 7.83123 9.84634 8 9.84634C8.16877 9.84634 8.33064 9.78151 8.44998 9.6661C8.56932 9.5507 8.63636 9.39418 8.63636 9.23098V2.10119L10.7316 4.12805C10.851 4.24352 11.0129 4.30839 11.1818 4.30839C11.3507 4.30839 11.5126 4.24352 11.632 4.12805C11.7515 4.01258 11.8185 3.85598 11.8185 3.69268C11.8185 3.52938 11.7515 3.37278 11.632 3.25731L8.45023 0.180479C8.39113 0.123264 8.32094 0.0778753 8.24369 0.0469074C8.16644 0.0159395 8.08363 0 8 0C7.91637 0 7.83356 0.0159395 7.75631 0.0469074C7.67906 0.0778753 7.60887 0.123264 7.54977 0.180479L4.36795 3.25731C4.24855 3.37278 4.18146 3.52938 4.18146 3.69268C4.18146 3.85598 4.24855 4.01258 4.36795 4.12805C4.48736 4.24352 4.64931 4.30839 4.81818 4.30839C4.98705 4.30839 5.149 4.24352 5.26841 4.12805Z"
        fill={color}
      />
    </svg>
  );
};

export default ShareUpIcon;
